import AnimateOverSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-over-symbol-behaviour";
import Contract from "slotworks/utils/contract";

export default class FrameOverSymbolBehaviour extends AnimateOverSymbolBehaviour {

    public stop(): Contract<void> {
        return this.animate("aaa", "anticframe1", false, false);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/matrix/symbols/frame-over-symbol-behaviour.ts